module.exports = __webpack_public_path__ + "static/09-2bd101f034eab2f8c195d2c844d8a2ec.jpg";